import React from 'react';

import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { Flex, UiText } from '@shared/ui';

import cls from './Budget.module.css';

interface IBudgetProps {
    value: string;
    className?: string;
}
export const Budget = ({ value, className }: IBudgetProps) => {
    const { t } = useTranslation();
    return (
        <Flex className={cn(cls.Budget, className)}>
            <UiText tag="h2" variant="mediumPlain" weight="bold">
                {t('PurchaseChart.Budget.text')} {value}
            </UiText>
        </Flex>
    );
};
